import { ADD_WATERJUG, ADD_WATERJUG_FAILED, ADD_WATERJUG_SUCCESS, UPDATE_WATERJUG, UPDATE_WATERJUG_FAILED, UPDATE_WATERJUG_SUCCESS, WATERJUG, WATERJUG_FAILED, WATERJUG_SUCCESS } from "./actionTypes"

let initialState = {
    waterjug: [],
    addWaterJug: "",
    updateWaterJug: "",
    loading: false,
    success: false,
    error: ''
}

export const waterJugReducer = (state = initialState, action) => {
    switch (action.type) {
        case WATERJUG: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case WATERJUG_SUCCESS: return {
            ...state,
            waterjug: action.payload,
            loading: false,
            success: true
        }
        case WATERJUG_FAILED: return {
            ...state,
            loading: false,
            success: false,
            error: action.payload
        }
        case ADD_WATERJUG: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case ADD_WATERJUG_SUCCESS: return {
            ...state,
            addWaterJug: action.payload,
            waterjug: [...state.waterjug, action.payload],
            loading: false,
            success: true,
            error: ''
        }
        case ADD_WATERJUG_FAILED: return {
            ...state,
            addWaterJug: [],
            loading: false,
            success: false,
            error: action.payload
        }
        case UPDATE_WATERJUG: return {
            ...state,
            loading: true,
            success: false,
            error: ''
        }
        case UPDATE_WATERJUG_SUCCESS: return {
            ...state,
            updateWaterJug: action.payload,
            waterjug: state.waterjug.map((item) => item.id === action.payload._id ? action.payload : item),
            loading: false,
            success: true,
            error: ''
        }
        case UPDATE_WATERJUG_FAILED: return {
            ...state,
            updateWaterJug: [],
            loading: false,
            success: false,
            error: action.payload
        }

        default: return state
    }
}